<template>
    <div class="botoes-container" :class="exibirVoltar ? 'justify-between' : 'justify-end'">
        <button v-if="exibirVoltar" class="botao-voltar" @click="voltar()">
            Voltar
        </button>
        <button :class="exibirSalvar ? 'botao-salvar' : 'botao-salvar-desabilitado'" @click="salvar()">
            <Icone :nome="'check_circle'" /> {{ labelSalvar }}
        </button>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import Icone from '@/components/Icone.vue'

export default defineComponent({
    name: 'Etapas',
    components: {
        Icone
    },
    props: {
        exibirVoltar: {
            type: Boolean,
            default: true
        },
        exibirSalvar: {
            type: Boolean,
            default: true
        },
        labelSalvar: {
            type: String,
            default: 'Salvar'
        },
    },
    emits: ['aoSalvar', 'aoVoltar'],
    methods: {
        salvar() {
            this.$emit('aoSalvar')
        },
        voltar() {
            this.$emit('aoVoltar')
        }
    }
})
</script>

<style scoped>
.botoes-container {
    @apply flex items-center fixed bottom-0 left-1/2 -translate-x-1/2 bg-white px-5 mx-auto mt-4 pt-5 pb-10 shadow-md w-screen desktop:w-2/4 md:w-3/4 z-50;
}
</style>